import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum ActionType {
  None = 0,
  'Send Email' = 1,
  'Assign To-Do' = 2,
  'Update Data' = 3,
  'Update Status' = 4,
  'Update Progress Status' = 5,
  'Update Receipt' = 6,
  'Update Priority Date' = 7,
  'Create Task' = 8,
}

export const ActionTypeList: EnumOption[] = createEnumOptions(ActionType);
